import { AxiosRequestConfig } from 'axios';
import axios from './axios';

export type MediaType = 'image' | 'video' | 'audio' | 'document';
export type MediaSource = 'AI' | 'USER_UPLOAD' | 'EXTERNAL';

export interface MediaOrigin {
	predictionId?: string;
	provider?: string;
	prompt?: string;
	refinedPrompt?: string;
	negativePrompt?: string;
	size?: string;
	guidanceScale?: number;
	numInferenceSteps?: number;
	seed?: number;
	enableBase64Output?: boolean;
}

export interface MediaItem {
	_id: string;
	userId: string;
	workspaceId: string;
	type: MediaType;
	source: MediaSource;
	category?: string;
	url: string;
	storageKey: string;
	mimeType?: string;
	sizeBytes?: number;
	width?: number;
	height?: number;
	origin?: MediaOrigin;
	createdAt: string;
	updatedAt?: string;
}

export const mediaService = {
	listAIMedia,
	listAICoverMedia,
	deleteMedia,
};

function listAIMedia(workspaceId?: string): Promise<MediaItem[]> {
	return new Promise(async (resolve, reject) => {
		try {
			const config: AxiosRequestConfig = {
				method: 'get',
				url: '/media',
				params: workspaceId ? { workspaceId } : undefined,
			};

			const resp = await axios(config);
			const response = resp?.data?.data ?? [];
			resolve(response);
		} catch (err) {
			const error = err as Error;
			reject(error);
		}
	});
}
function listAICoverMedia(workspaceId?: string): Promise<MediaItem[]> {
	return new Promise(async (resolve, reject) => {
		try {
			const config: AxiosRequestConfig = {
				method: 'get',
				url: 'media/covers',
				params: workspaceId ? { workspaceId } : undefined,
			};

			const resp = await axios(config);
			const response = resp?.data?.data ?? [];
			resolve(response);
		} catch (err) {
			const error = err as Error;
			reject(error);
		}
	});
}

function deleteMedia(ids: string[]): Promise<{ deletedCount: number; ids: string[] }> {
	return new Promise(async (resolve, reject) => {
		try {
			if (!ids?.length) throw new Error('No media ids provided');
			const params = new URLSearchParams();
			params.set('_id', ids.join(','));

			const config: AxiosRequestConfig = {
				method: 'delete',
				url: `/media?${params.toString()}`,
			};

			const resp = await axios(config);
			const response = resp?.data?.data ?? { deletedCount: 0, ids: [] };
			resolve(response);
		} catch (err) {
			const error = err as Error;
			reject(error);
		}
	});
}
